<template>
  <form id="form-add-allergy" class="position-relative">
    <loader :loading="loadingForm" block />
    <div class="vuedl-layout__closeBtn" @click="close(true)">
      ×
    </div>
    <v-card>
      <v-card-title class="headline grey lighten-2 mb-4 justify-center" primary-title>
        {{ isUpdate ? "Обновить" : "Добавить" }} аллергию
      </v-card-title>

      <v-divider class="my-2"></v-divider>

      <v-card-text class="py-1">
        <date-picker
          label="Дата обнаружения"
          :hide-details="false"
          v-model="form.dateStart"
          :error-messages="dateStartErrors"
          @input="$v.form.dateStart.$touch()"
          @blur="$v.form.dateStart.$touch()"
        />
      </v-card-text>

      <v-card-text class="py-1">
        <v-select
          label="Тип аллергии"
          item-value="id"
          item-text="name"
          v-model="form.type"
          :loading="loadingFormFields"
          :items="allergyTypeList"
          :error-messages="typeErrors"
          @change="
            $v.form.type.$touch();
            onSelectType();
          "
          @blur="$v.form.type.$touch()"
        ></v-select>
      </v-card-text>

      <v-card-text class="py-1">
        <v-select
          multiple
          label="Аллерген"
          item-value="id"
          item-text="name"
          v-model="form.allergens"
          :loading="loadingAllergens"
          :items="allergenList"
          :disabled="!form.type"
          :error-messages="allergenErrors"
          :menu-props="{ closeOnContentClick: true }"
          @change="$v.form.allergens.$touch()"
          @blur="$v.form.allergens.$touch()"
        ></v-select>
      </v-card-text>

      <v-card-text class="py-1">
        <v-select
          multiple
          label="Где проявляется"
          item-value="id"
          item-text="name"
          v-model="form.areas"
          :menu-props="{ closeOnContentClick: true }"
          :items="areaList"
          :loading="loadingFormFields"
          :error-messages="areaErrors"
          @change="$v.form.areas.$touch()"
          @blur="$v.form.areas.$touch()"
        ></v-select>
      </v-card-text>

      <v-card-text class="py-1">
        <v-select
          multiple
          label="Реакция"
          item-value="id"
          item-text="name"
          v-model="form.reactions"
          :menu-props="{ closeOnContentClick: true }"
          :items="reactionList"
          :loading="loadingFormFields"
          :error-messages="reactionErrors"
          @change="$v.form.reactions.$touch()"
          @blur="$v.form.reactions.$touch()"
        ></v-select>
      </v-card-text>

      <v-card-text class="py-1">
        <v-select
          label="Степень"
          item-value="id"
          item-text="name"
          v-model="form.degree"
          :items="degreeList"
          :loading="loadingFormFields"
          :error-messages="degreeErrors"
          @change="$v.form.degree.$touch()"
          @blur="$v.form.degree.$touch()"
        ></v-select>
      </v-card-text>

      <v-divider class="mt-4"></v-divider>

      <v-card-actions>
        <v-btn id="form-add-cancel" color="primary" text @click="close(true)">Отменить</v-btn>
        <v-spacer></v-spacer>
        <v-btn id="form-add-allergy-submit" color="primary" text @click="submit">
          Сохранить
        </v-btn>
      </v-card-actions>
    </v-card>
  </form>
</template>

<script>
import DatePicker from "@/components/forms/DatePicker";
// import throttle from 'lodash/throttle';
import { required } from "vuelidate/lib/validators";
import { messageHelper } from "@/services/validation-helper";
import Loader from "@/components/Loader";
import { AllergyService } from "@/services/api/allergy.service";

// Дефолтное состояние формы
const formState = {
  dateStart: null, //user_allergy_date
  type: null, //user_allergy_type
  allergens: [], //user_allergy_allergy
  areas: [], //user_allergy_area
  reactions: [], //user_allergy_reaction
  degree: null, //user_allergy_degree
};

export default {
  name: "AddAllergy",

  components: { Loader, DatePicker },

  props: {
    model: {
      type: Object,
    },
  },

  data: () => ({
    loadingForm: false,
    loadingFormFields: false,
    loadingAllergens: false,

    allergyTypeList: [],
    allergenList: [],
    areaList: [],
    reactionList: [],
    degreeList: [],

    form: { ...formState },
  }),

  validations: {
    form: {
      dateStart: { required },
      type: { required },
      allergens: { required },
      areas: { required },
      reactions: { required },
      degree: { required },
    },
  },

  computed: {
    isUpdate() {
      return !!this.model;
    },

    dateStartErrors() {
      return messageHelper(this.$v.form.dateStart);
    },

    typeErrors() {
      return messageHelper(this.$v.form.type);
    },

    allergenErrors() {
      return messageHelper(this.$v.form.allergens);
    },

    areaErrors() {
      return messageHelper(this.$v.form.areas);
    },

    reactionErrors() {
      return messageHelper(this.$v.form.reactions);
    },

    degreeErrors() {
      return messageHelper(this.$v.form.degree);
    },
  },

  watch: {},

  created() {
    this.mapModelToForm();
  },

  async mounted() {
    await this.loadFormData();
  },

  methods: {
    async loadFormData() {
      this.loadingFormFields = true;
      const [types, areas, reactions, degrees] = await Promise.all([
        AllergyService.getTypes(),
        AllergyService.getAreas(),
        AllergyService.getReactions(),
        AllergyService.getDegrees(),
      ]);

      this.loadingFormFields = false;
      this.allergyTypeList = types;
      this.areaList = areas;
      this.reactionList = reactions;
      this.degreeList = degrees;
    },

    loading(val) {
      this.loadingForm = val;
      this.$emit("loading", val);
    },

    /**
     * Закрытия модального окна
     */
    close() {
      this.resetForm();
      this.$emit("close");
      this.$emit("submit", false);
    },

    /**
     * Сброс формы
     */
    resetForm() {
      this.$v.$reset();
      this.form = { ...formState };
    },

    /**
     * Отправка формы
     */
    async submit() {
      this.$v.form.$touch();
      if (this.$v.form.$pending || this.$v.form.$error) return;
      this.loading(true);

      const formData = {
        date_start: this.form.dateStart,
        type: this.form.type,
        allergens: this.form.allergens,
        areas: this.form.areas,
        reactions: this.form.reactions,
        degree: this.form.degree,
      };

      if (this.isUpdate) {
        await this._updateItem(formData);
      } else {
        await this._createItem(formData);
      }
    },

    async _createItem(formData) {
      try {
        const response = await this.$http.post(`v1/customers/${this.$store.state.customer.id}/allergies`, formData);

        this.loading(false);
        this.$store.commit("allergies/ADD_ITEM", response.data.data);
        this.$store.commit("allergies/INCREASE_META_TOTAL", response.data.data);
        this.$notify.showMessage(response.data.message, "success");
        this.close();
      } catch (e) {
        this.loading(false);
        this.$notify.showMessage(e.response.message, "error");
      }
    },

    async _updateItem(formData) {
      try {
        const r = await this.$http.put(`v1/customers/${this.$store.state.customer.id}/allergies/${this.model.id}`, formData);

        this.loading(false);
        this.$store.commit("allergies/UPDATE_ITEM", this.getUpdatedModel());
        this.$notify.showMessage(r.data.message, "success");
        this.close();
      } catch (e) {
        this.loading(false);
        if (e.response) {
          this.$notify.showMessage(e.response.message, "error");
        }
      }
    },

    /**
     * Загружает список алергенов для выбраного типа
     */
    async onSelectType() {
      this.form.allergens = [];
      this.loadingAllergens = true;
      this.allergenList = await AllergyService.getAllergens(this.form.type);
      this.loadingAllergens = false;
    },

    async mapModelToForm() {
      if (this.isUpdate) {
        this.form.dateStart = this.model.date_start;
        this.form.type = this.model.type.translation_id;
        this.form.allergens = this.model.allergens.map(a => +a.id);
        this.form.areas = this.model.areas.map(a => +a.allergy_area_id);
        this.form.reactions = this.model.reactions.map(i => +i.allergy_reaction_id);
        this.form.degree = this.model.degree.allergy_degree_id;
        AllergyService.getAllergens(this.form.type).then(data => {
          this.allergenList = data;
        });
      }
    },

    getUpdatedModel() {
      const type = this.allergyTypeList.find(t => t.id === this.form.type);
      const degree = this.degreeList.find(d => d.id === this.form.degree);

      /** @type {AllergyItem} */
      const model = {
        ...this.model,
        date_start: this.form.dateStart,
        type: type.name,
        allergens: this.allergenList.filter(a => this.form.allergens.includes(a.id)).map(a => a.name),
        areas: this.areaList.filter(a => this.form.areas.includes(a.id)).map(a => a.name),
        reactions: this.reactionList.filter(r => this.form.reactions.includes(r.id)).map(r => r.name),
        degree: degree.name,
      };

      console.log("model", model);

      return model;
    },
  },
};
</script>
